import api from "@/services/api";
import { PremiumNetworkType } from "@/types/premium/PremiumNetwork";

export type PremiumNetworkFilters = {
  premiumStatus?: string;
  level?: number;
  periodStart?: string;
  periodEnd?: string;
};

class GetPremiumNetwork {
  execute = async (
    franchiseId: string,
    filters: PremiumNetworkFilters = {},
  ) => {
    const response = await api().get("/associate-premium/network", {
      params: {
        franchiseId,
        ...filters,
      },
    });
    return response.data as PremiumNetworkType;
  };
}

export { GetPremiumNetwork };
